import { render, staticRenderFns } from "./BaseLoadingState.vue?vue&type=template&id=2b491a19&scoped=true&"
import script from "./BaseLoadingState.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingState.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingState.vue?vue&type=style&index=0&id=2b491a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b491a19",
  null
  
)

export default component.exports